module.exports = __webpack_public_path__ + "static/media/mobile.73103994.svg";


//////////////////
// WEBPACK FOOTER
// ./src/blocks/footer/static/img/mobile.svg
// module id = 2067
// module chunks = 118